<template>
  <el-select @change="changeValue" v-model.nubmer="userId" placeholder="选择人员"  style="width: 100px;" size="mini" filterable>
    <el-option
     key="0"
     :label="defaultOption.CnName"
     :value="defaultOption.id"
    >

    </el-option>
    <el-option
      v-for="item in options"
      :key="item.id"
      :label="item.CnName"
      :value="item.id" size="mini">
    </el-option>
  </el-select>
</template>

<script>
import { findPeople } from '@/api/base'
export default {
  name: 'selectUser',
  props: {
    options: Array,
    userId: Number,
    code: '',
  },
  data() {
    return {
      options:[],
      defaultOption:{
        CnName:'全部',
        id:0
      },
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init(){
      findPeople({code:this.code}).then(res => {
        this.options = res.data.data.list
      })
    },
    changeValue() {
      this.$emit('update:userId', this.userId)
      this.$emit("success", this.userId)
    },
    clearValue(){
      this.userId = null
    }
  }
}
</script>

<style scoped>
  
</style>
<!-- 参数type  回调方法select -->